import { useSelector } from "react-redux";

const useClientConfig = () => {
    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    const isMicroSite = clientConfig?.data?.data?.clientSettings?.isMicroSite;
    const clientSiteSettings = clientConfig?.data?.data?.clientSettings?.clientSiteSettings;
    const clientMenuSettings = clientConfig?.data?.data?.clientSettings?.clientMenuSettings;
    const clientAssetsLink = clientConfig?.data?.data?.clientSettings?.assetsLink;
    return { clientConfig, clientSiteSettings, clientMenuSettings, clientAssetsLink, isMicroSite };
};

export default useClientConfig;